import { HttpClient } from '@angular/common/http';
import * as moment from 'moment';
moment.locale('pt-Br');

export class LocalUtils {

  constructor(private http: HttpClient) {}

    static encrypt(param) {
        if(param){
            return btoa(btoa(btoa(param))).toString();
        }else{
            return param;
        }
    }

    static decrypt(param) {
        if(param){
            return atob(atob(atob(param))).toString();
        }else{
            return param;
        }
    }

    static expiredToken(error){
        if(error && error.error && error.error.errorCode == 40030){ 
            this.logout();
        }else{
            return error
        }
    }

    static verify(room, rooms) {
        for (let i = 0; i < rooms.length; i++) {
            if(room == rooms[i].room.toString()){
                return true
            }
        }
        return false;
    }

    static getUser() {
        let user = JSON.parse(this.decrypt(localStorage.getItem("user")));
        return user;
    }

    // static timestamps(param){
    //     if(!param || !param.timestamps || param.timestamps < moment().subtract(5, 'days').format('YYYY-MM-DD HH:mm:ss')){
    //         this.logout();
    //     }
    // }

    // static momento() {
    //     return moment().format('YYYY-MM-DD HH:mm:ss');
    // }

    static logout(){
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        window.location.reload(true);
    }

    static getNotificationConfig() {
        return {
            timeOut: 3000,
            showProgressBar: true,
            pauseOnHover: false,
            clickToClose: false,
            maxLength: 30
        }
    }

    static getNotificationOptions() {
        return {
            position: ["top", "right"],
            timeOut: 5000,
            lastOnBottom: true
        }
    }

    // static isAdmin(): boolean{
    //     let user = (JSON.parse(this.decrypt(localStorage.getItem('user'))));
    //     return  user && user.profile && user.profile.description &&  user.profile.description == 'Admin';
    // }
    // static isManager(): boolean{
    //     let user = (JSON.parse(this.decrypt(localStorage.getItem('user'))));
    //     if(user && user.profile && user.profile.id && user.profile.id == 30){
    //        return  true;
    //     }else{
    //        return false;
    //     }
    // }
    // static isAdmManager(): boolean{
    //     let user = (JSON.parse(this.decrypt(localStorage.getItem('user'))));
    //     if(user && user.profile && user.profile.id && user.profile.id == 40){
    //        return  true;
    //     }else{
    //        return false;
    //     }
    // }

    static getEnrolmentId(): number{
        let user = (JSON.parse(this.decrypt(localStorage.getItem('user'))));
        if(user && user.username){
           return user.username;
        }else{
           return undefined;
        }
    }

    static menssage(status) {
        switch(status) {
            case 200: return {type: 'success', name: 'Sucesso', menssage: 'Solicitação feita com sucesso!'};
            case 204: return {type: 'success', name: 'Sucesso', menssage: 'Solicitação feita com sucesso!'};
            case 400: return {type: 'danger', name: 'Erro', menssage: 'Solicitação mal feita!'};
            case 401: return {type: 'danger', name: 'Não Autorizado', menssage: 'Solicitação não autorizada!'};
            case 402: return {type: 'danger', name: 'Erro', menssage: 'Ocorreu um erro na solicitação, por favor entre em contato com o administrador!'};
            case 403: return {type: 'danger', name: 'Erro', menssage: 'Ocorreu um erro na solicitação, por favor entre em contato com o administrador!'};
            case 404: return false;
            case 405: return {type: 'danger', name: 'Erro', menssage: 'Ocorreu um erro na solicitação, por favor entre em contato com o administrador!'};
            case 406: return {type: 'danger', name: 'Erro', menssage: 'Erro no envio de e-mail!'};
            case 409: return {type: 'danger', name: 'Erro', menssage: 'Solicitação já existe!'};
            case 410: return {type: 'danger', name: 'Erro', menssage: 'Ocorreu um erro na solicitação, por favor entre em contato com o administrador!'};
            case 411: return {type: 'danger', name: 'Erro', menssage: 'Ocorreu um erro na solicitação, por favor entre em contato com o administrador!'};
            case 412: return {type: 'danger', name: 'Licença', menssage: 'Erro na capacidade de licença!'};
            case 500: return {type: 'danger', name: 'Erro', menssage: 'Ocorreu um erro na solicitação, por favor entre em contato com o administrador!'};
            default: return {type: 'danger', name: 'Erro', menssage: 'Ocorreu um erro na solicitação, por favor entre em contato com o administrador!'};
        }
    }

    static encode (input) {
        let keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
        let output = "";
        let chr1, chr2, chr3, enc1, enc2, enc3, enc4;
        let i = 0;

        while (i < input.length) {
            chr1 = input[i++];
            chr2 = i < input.length ? input[i++] : Number.NaN;
            chr3 = i < input.length ? input[i++] : Number.NaN;

            enc1 = chr1 >> 2;
            enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
            enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
            enc4 = chr3 & 63;

            if (isNaN(chr2)) {
                enc3 = enc4 = 64;
            } else if (isNaN(chr3)) {
                enc4 = 64;
            }
            output += keyStr.charAt(enc1) + keyStr.charAt(enc2) + keyStr.charAt(enc3) + keyStr.charAt(enc4);
        }
        return output;
    }

    static colorsDefault = {
        buttonColor: 'warning',
        navbarColor: '#ffffff',
        sidebarColor: '#696969',
        itemSidebarColor: '#828282',
        hoverSidebarColor: '000000',
        emailBackgroundColor: '#ffffff',
        emailColor: '#ff9a2b'
    }

    static colorsDefault2 = {
        buttonColor: 'warning',
        navbarColor: '#ffffff',
        sidebarColor: '#696969',
        itemSidebarColor: '#828282',
        hoverSidebarColor: '000000',
        emailBackgroundColor: '#ffffff',
        emailColor: '#ff9a2b'
    }

    static imagesDefault = {
        logo: '/assets/img/logo_c.png',
        logo2: '/assets/img/logo.png',
        miniLogo: '/assets/img/logo-mini.png',
        logoHeight: 35,
        logoWidth: 150,
        divWidth: 250,
        divHeight: 60,
        marginTop: 12,
        minimized: false,
        meetingImage: '/assets/img/default/meeting.png',
        meetingImageActive: '/assets/img/default/meeting-active.png',
        scheduleImage: '/assets/img/default/schedule.png',
        scheduleImageActive: '/assets/img/default/schedule-active.png',
        recordingImage: '/assets/img/default/recording.png',
        recordingImageActive: '/assets/img/default/recording-active.png',
        reportImage: '/assets/img/default/reports.png',
        reportImageActive: '/assets/img/default/reports-active.png',
        instructionImage: '/assets/img/default/instructions.png',
        play: '/assets/img/default/play.png',
        favicon: '/assets/img/favicon.ico',

        meetingroomImage: '/assets/img/icon-meetingroom1.png',
        meetingroomActive: '/assets/img/icon-meetingroom2.png',
        endpointImage: '/assets/img/icon-endpoint1.png',
        endpointActive: '/assets/img/icon-endpoint2.png',
        calendarImage: '/assets/img/icon-calendar1.png',
        calendarActive: '/assets/img/icon-calendar2.png',
        smartroomImage: '/assets/img/icon-smartroom1.png',
        smartroomActive: '/assets/img/icon-smartroom2.png',
        meetingroomReport: '/assets/img/default/icon-meetingroom-reports1.png',
        meetingroomReportActive: '/assets/img/default/icon-meetingroom-reports2.png',
        // meetingroomImage: '/assets/img/default/meetingroom.png',
        // meetingroomActive: '/assets/img/default/meetingroom-active.png',
        // endpointImage: '/assets/img/default/endpoint.png',
        // endpointActive: '/assets/img/default/endpoint-active.png',
        // calendarImage: '/assets/img/default/calendar.png',
        // calendarActive: '/assets/img/default/calendar-active.png',
        // smartroomImage: '/assets/img/default/smartroom.png',
        // smartroomActive: '/assets/img/default/smartroom-active.png',
        onCalendarEvents: '/assets/img/icon-event1.png',
        onCalendarEventsActive: '/assets/img/icon-event2.png',
        onCalendarConfig: '/assets/img/icon-settings1.png',
        onCalendarConfigActive: '/assets/img/icon-settings2.png',
        onDesk: '/assets/img/icon-desk1.png',
        onDeskActive: '/assets/img/icon-desk2.png'
    }

    async getUserLanguage() {
      let userLanguage = JSON.parse(localStorage.getItem('language'));
      if(!userLanguage) {
        localStorage.setItem('language', JSON.stringify('pt-br'));
        userLanguage = 'pt-br';
      }

      const response = await this.http.get('./assets/language.json').toPromise();

      return response[userLanguage];
    }
}



// WEBPACK FOOTER //
// ./src/app/restricted/restricted.utils.ts